import styled, { css, keyframes } from 'styled-components';

// Мягкий, малозаметный shimmer — без резких бликов, чтобы плашки не
// «мигали» в глаза при коротких загрузках (часто данные приезжают за
// 100-200мс). Анимация затухающая, низкоконтрастная.
const shimmer = keyframes`
  0%   { background-position: -200% 0; }
  100% { background-position:  200% 0; }
`;

const fadeIn = keyframes`
  from { opacity: 0; }
  to   { opacity: 1; }
`;

interface SkeletonProps {
  $width?: string | number;
  $height?: string | number;
  $radius?: string;
  $inline?: boolean;
}

export const Skeleton = styled.div<SkeletonProps>`
  display: ${({ $inline }) => ($inline ? 'inline-block' : 'block')};
  width: ${({ $width }) => (typeof $width === 'number' ? `${$width}px` : ($width ?? '100%'))};
  height: ${({ $height }) => (typeof $height === 'number' ? `${$height}px` : ($height ?? '14px'))};
  border-radius: ${({ $radius, theme }) => $radius ?? theme.radius.sm};
  position: relative;
  overflow: hidden;
  background: ${({ theme }) => theme.colors.surface};
  animation: ${fadeIn} 220ms ${({ theme }) => theme.motion.easeOut};

  ${({ theme }) => css`
    &::after {
      content: '';
      position: absolute;
      inset: 0;
      background-image: linear-gradient(
        90deg,
        transparent 0%,
        ${theme.colors.border}55 50%,
        transparent 100%
      );
      background-size: 200% 100%;
      animation: ${shimmer} 1.6s ease-in-out infinite;
      opacity: 0.7;
    }
  `}
`;

export const SkeletonLine = styled(Skeleton)`
  margin: 4px 0;
`;
